import Parser from 'html-react-parser';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

const TestMessage = () => {
  const { t } = useTranslation();
  if (process.env.REACT_APP_ENV !== 'production') {
    return <div className={styles.test_message}>{Parser(t('common.testMessage'))}</div>;
  }
  return <></>;
};

export default TestMessage;
